import { render } from "./index.vue?vue&type=template&id=038e7047&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=038e7047&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038e7047"],['__file',"src/views/layout/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "038e7047"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('038e7047', __exports__)) {
    api.reload('038e7047', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=038e7047&scoped=true&ts=true", () => {
    api.rerender('038e7047', render)
  })

}


export default __exports__